import { render, staticRenderFns } from "./BnTabs.vue?vue&type=template&id=0d6c8ef1&scoped=true&"
import script from "./BnTabs.vue?vue&type=script&lang=js&"
export * from "./BnTabs.vue?vue&type=script&lang=js&"
import style0 from "./BnTabs.vue?vue&type=style&index=0&id=0d6c8ef1&scoped=true&lang=css&"
import style1 from "./BnTabs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6c8ef1",
  null
  
)

export default component.exports